/* Hide the site-tutorial button ("מדריך לאתר") after the visitor finishes
   or skips the tour. Remembered in localStorage as dez_tutorial_fab_hidden_v1.

   The tutorial is the Site Tutorial app embed. Its buttons call a closed-over
   endTour(), not window.SiteTutorial.end, so wrapping the public API does not
   see Skip / סיום / Escape. site_tutorial_seen_v1 is written when the tour
   STARTS (and the theme sets it to hold auto-start), so it does not mean
   "finished".

   Completion is detected from the app's own controls:
   - #st-skip ("דלג") always ends the tour.
   - #st-next labeled "סיום" ends it, except when that click continues the
     multi-page tour (sessionStorage site_tutorial_flow_v1 phase
     on-collection / await-swipe-back / after-back). On mobile the last
     homepage step is also labeled סיום but then navigates to a collection.
   - Escape ends it the same way, and is ignored while a continue-phase is set
     or while the overlay is still open.
   Removing the overlay alone is not treated as completion: the app removes it
   while moving between pages, then starts the next step. */
(function () {
  var KEY = "dez_tutorial_fab_hidden_v1";
  var FLOW_KEY = "site_tutorial_flow_v1";
  var CONTINUE = {
    "await-swipe-back": 1,
    "after-back": 1,
    "on-collection": 1,
  };

  function markDone() {
    try {
      localStorage.setItem(KEY, "1");
    } catch (e) {}
    document.documentElement.classList.add("dez-tutorial-done");
  }

  function readPhase() {
    try {
      var raw = sessionStorage.getItem(FLOW_KEY);
      if (!raw) return "";
      var data = JSON.parse(raw);
      return data && data.phase ? String(data.phase) : "";
    } catch (e) {
      return "";
    }
  }

  function overlayOpen() {
    var overlay = document.getElementById("st-overlay");
    return !!(overlay && overlay.classList.contains("is-visible"));
  }

  function considerFinish() {
    window.setTimeout(function () {
      if (CONTINUE[readPhase()]) return;
      var overlay = document.getElementById("st-overlay");
      if (!overlay || overlay.classList.contains("is-visible")) return;
      markDone();
    }, 60);
  }

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest("#st-skip")) {
        markDone();
        return;
      }
      var next = target.closest("#st-next");
      if (!next || next.hidden) return;
      if ((next.textContent || "").replace(/\s+/g, " ").trim() === "סיום") considerFinish();
    },
    true
  );

  document.addEventListener(
    "keydown",
    function (event) {
      if (event.key === "Escape") {
        if (!overlayOpen()) return;
        considerFinish();
        return;
      }
      if (event.key !== "Enter" || !overlayOpen()) return;
      var next = document.getElementById("st-next");
      if (!next || next.hidden) return;
      if ((next.textContent || "").replace(/\s+/g, " ").trim() === "סיום") considerFinish();
    },
    true
  );

  function hookApi() {
    var api = window.SiteTutorial;
    if (!api || api.__dezFabHooked || typeof api.end !== "function") return false;
    var original = api.end;
    api.end = function (opts) {
      var result = original.apply(this, arguments);
      if (opts && opts.keepFlow) return result;
      considerFinish();
      return result;
    };
    api.__dezFabHooked = true;
    return true;
  }

  if (!hookApi()) {
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (hookApi() || tries > 40) window.clearInterval(timer);
    }, 250);
  }
})();
